/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 5/27/15.
 */

'use strict';

function PackageMetadataViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    $filter: JS5Function,
    $scope: JS5Object,
    $timeout: JS5Function,
    PackageUtilService: JS5Object,
    MetadataService: JS5Object,
    PackageResourceFactory: JS5Object,
    LanguageResourceFactory: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    PartnerPackagesService: JS5Object,
    NotificationService: JS5Object,
    RatingsService: JS5Object,
    DynamicPropertiesService: JS5Object)
{
    const META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
    const ORD_VIEW_STATE = 'PACKAGE_ORD_VIEW_STATE';
    this.showAcceptedAndRejected = false;
    let originalPackageData = [];

    const lockFields = () => {
        const delivered = this.packageObject.revision > 1;
        this.lockableFields.title =
            this.packageObject.categoryType.name === 'Long Form' &&
            this.packageObject.title &&
            delivered;
        this.lockableFields.productionNumber =
            this.packageObject.categoryType.name === 'Long Form' &&
            this.packageObject.productionNumber &&
            delivered;
        this.lockableFields.category = !!this.packageObject.category;
        this.lockableFields.originalReleaseDate =
            this.packageObject.categoryType.name === 'Long Form' &&
            this.packageObject.originalReleaseDate && (!this.ordPerms && !this.packageObject.clone || delivered);
        this.lockableFields.season = this.packageObject.season && delivered;
        this.lockableFields.volume = this.packageObject.volume && delivered;
    };

    const composeMetadataComponents = (packageObject: JS5Object) => {
        this.metadataComponentsMap = MetadataService.buildCustomComponentMap(
            packageObject.metadata.properties,
            PackageUtilService.errorsAndWarnings()[packageObject.name],
            true
        );

        this.metadataComponentsMap =
            PackageUtilService.metadataComponentsMap =
                _.pickBy(
                    this.metadataComponentsMap,
                    (pkgMetaProp: JS5Object) => {
                        return !pkgMetaProp.advanced;
                    });
    };

    this.onRatingSystemChange = () => {
        this.packageObject.rating.ratingCode = {};
        this.packageObject.rating.ratingAdvisoryCodes = [];
        this.advisoryCodes = [];
        PackageUtilService.editorForm.$setDirty();
    };

    let setAdvisoryCodes = () => {
        this.advisoryCodes = [];

        let advisoryCodes = _.get(this, 'ratingSystem.advisoryCodes', []);
        let applicableAdvisoryCodes = _.get(this.packageObject, 'rating.ratingCode.applicableAdvisoryCodes', []);
        this.advisoryCodes = _.filter(advisoryCodes, (advisoryCode: JS5Object) => {
            return _.includes(applicableAdvisoryCodes, advisoryCode.advisoryCode);
        });
    }

    this.onRatingChange = () => {
        _.set(this.packageObject, 'rating.ratingAdvisoryCodes', []);
        setAdvisoryCodes();
    };

    this.onRatingClear = () => {
        this.onRatingChange();
    }

    this.ratingSystem = undefined;

    this.setRatingSystem = (packageObject: JS5Object) => {
        let ratingSystemCode = DynamicPropertiesService.getPropValue('package.ratingSystem.default');
        ratingSystemCode = _.isUndefined(ratingSystemCode) ? 'us-tv' : ratingSystemCode;
        if (!_.isUndefined(_.get(packageObject, 'rating.ratingCode'))) {
            ratingSystemCode = RatingsService.getRatingSystemByRatingCode(
                this.ratingSystems,
                packageObject.rating.ratingCode).systemCode;
        }
        this.ratingSystem = this.ratingSystems[ratingSystemCode];
    };

    const getEditData = () => {
        this.loadingIndicator.show = true;
        this.isAdmin = PermissionsService.isAdmin();
        this.languages = LanguageResourceFactory.query({});
        this.availableCategories = PackageResourceFactory.query({
            sub: 'categories',
            id: $routeParams.id
        });
        let metaServicePromise = MetadataService.propertiesPromise;
        let languagePromise = this.languages.$promise;
        let categoriesPromise = this.availableCategories.$promise;
        let ratingSystemsPromise = RatingsService.getRatingSystems();
        let writePermsPromise = PermissionsService.canWrite(META_TAB_VIEW_STATE);
        let ordWritePromise = PermissionsService.canWrite(ORD_VIEW_STATE);
        $location.search('subView', null);

        let promises: JS5Object = {
            languages: languagePromise,
            metaService: metaServicePromise,
            categories: categoriesPromise,
            ratingSystems: ratingSystemsPromise,
            write: writePermsPromise,
            ord: ordWritePromise,
        };
        if (this.packageObject.content.type === 'Series') {
            promises.seasons = PackageResourceFactory.query({
                sub: 'seasons',
                id: $routeParams.id
            }).$promise;
            promises.volumes = PackageResourceFactory.query({
                sub: 'volumes',
                id: $routeParams.id
            }).$promise;
        }

        return $q.all(promises).then((editData: JS5Object) => {
            if (this.packageObject.clone) {
                const categoriesFilter = {
                    cloneable: true
                };
                this.availableCategories = $filter('filter')(this.availableCategories, categoriesFilter);
            }

            composeMetadataComponents(this.packageObject);
            this.languages = _.chain(this.languages).partition({isDefault: true}).flatten().value();
            this.availableSeasons = editData.seasons;
            this.availableVolumes = editData.volumes;
            this.ratingSystems = editData.ratingSystems;
            this.ratingSystemValues = _.values(this.ratingSystems);
            this.writePerms = editData.write;
            this.ordPerms = editData.ord;
            this.loading = false;

            lockFields();
            this.setRatingSystem(this.packageObject);
            setAdvisoryCodes();
            originalPackageData = angular.copy(this.packageObject);
            this.loadingIndicator.show = false;
        });
    };

    this.lockInitializer = () => {
        return false;
    };


    const packageSaved = () => {
        lockFields();
        PackageUtilService.createErrorsAndWarningsMap(this.packageObject.validationResult);
        composeMetadataComponents(this.packageObject);
    };

    this.revertMetadata = (packageObject: JS5Object) => {
        this.setRatingSystem(packageObject);
        composeMetadataComponents(packageObject);
    };

    this.contentSelectionHandler = (newContent: JS5Object) => {
        if (newContent.id !== this.packageObject.content.id) {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to update package content?',
                pullCancelLeft: true,
                title: 'Update Content',
                windowClass: 'confirm-modal-sm',
                showOK: true,
                okText: 'Yes',
                cancelText: 'No'
            }, (confirmationResult: string) => {
                if (confirmationResult === 'OK') {
                    this.packageObject.content = newContent;
                    this.packageMetadataEditorForm.$setDirty();
                    PackageUtilService.tabSaveFunction().then(function () {
                        // the DTO isn't refreshed on save, so
                        // manually grab the new data to get e.g.
                        // the new categories
                        getEditData();
                    });
                }
            });
        }
    };

    this.changeContent = () => {
        ModalService.showContentSelectModal(this.packageObject.content.type, undefined, this.contentSelectionHandler);
    };

    this.isRatingRequired = () => {
        return this.packageObject.content.type === 'Series';
    };

    this.hasVolumes = () => {
        return (
            this.packageObject.content.type === 'Series' &&
            !!this.availableVolumes &&
            this.availableVolumes.length > 0
        );
    };

    this.showApprovalMessage = (partnerPackage: JS5Object) => {
        ModalService.showMessageModal({
            messageText: `Message: ${partnerPackage.approvalMessage}`,
            title: `${_.capitalize(partnerPackage.approvalStatus)} ${partnerPackage.partnerName} Pre-Delivery QC Approval`,
            windowClass: 'confirm-modal-lg',
            showOK: true,
            showCancel: false
        })
    };

    this.showApprovePartnerPackageModal = (partnerPackage: JS5Object) => {
        ModalService.showPartnerPackageAcceptRejectModal(
            'Accept',
            partnerPackage.partnerName,
            (approvalMessage: string) => {
                approvePartnerPackageForPreDeliveryQc(partnerPackage, approvalMessage);
            })
    };

    const approvePartnerPackageForPreDeliveryQc = (partnerPackage: JS5Object, message: string) => {
        this.loadingIndicator.show = true;
        PartnerPackagesService.approvePartnerPackageForPreDeliveryQc(partnerPackage.id, message).then(() => {
            NotificationService.createSuccessNotification(`Accepted ${partnerPackage.partnerName} Pre-Delivery QC Approval.`, 5000);
            getPackageStatus();
        }).catch((error)=>{
            NotificationService.createFailureNotification(`Could not Accept ${partnerPackage.partnerName} Pre-Delivery QC Approval. [${error}]`);
        }).finally(()=>{
            this.loadingIndicator.show = false;
        });
    };

    this.showRejectPartnerPackageModal = (partnerPackage: JS5Object) => {
        ModalService.showPartnerPackageAcceptRejectModal(
            'Reject',
            partnerPackage.partnerName,
            (approvalMessage) => {
                rejectPartnerPackageForPreDeliveryQc(partnerPackage, approvalMessage);
            })
    };

    const rejectPartnerPackageForPreDeliveryQc = (partnerPackage: JS5Object, message: string) => {
        this.loadingIndicator.show = true;
        PartnerPackagesService.rejectPartnerPackageForPreDeliveryQc(partnerPackage.id, message).then(() => {
            NotificationService.createSuccessNotification(`Rejected ${partnerPackage.partnerName} Pre-Delivery QC Approval.`, 5000);
            getPackageStatus();
        }).catch((error)=>{
            console.error(`Could not Reject ${partnerPackage.partnerName}. [${error}]`);
            NotificationService.createFailureNotification(`Could not Reject ${partnerPackage.partnerName} Pre-Delivery QC Approval. [${error}]`);
        }).finally(()=>{
            this.loadingIndicator.show = false;
        });
    };

    const getPackageStatus = () => {
        PackageResourceFactory.get({
            id: $routeParams.id,
            view: 'STATUS'
        }).$promise
            .then((packageData) => {
                this.pendingPartnerPackages = packageData.pendingPartnerPackages;
            })
    };
    // **************************************************************** //
    // **************************************************************** //
    // **** Seriously! Always perform this action before you save  **** //
    // **** metadata items to ensure the correct data is persisted **** //
    // **************************************************************** //
    // **************************************************************** //
    this.onMetadataUpdate = (event: any) => {
        this.validationErrors = event.errors;
        if (!this.validationErrors) {
            this.metadataComponentsMap[event.name].instanceData.value = event.items;
        }
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        // Map of lockable fields and isLocked status
        this.lockableFields = {
            title: false,
            productionNumber: false,
            category: false,
            originalReleaseDate: false,
            season: false,
            volume: false
        };

        this.isAdmin = false;
        this.loading = true;

        this.metadataComponentsMap = {};
        this.advisoryCodes = [];

        // Set event handlers in PackageUtilService
        PackageUtilService.tabRevertFunction = this.revertMetadata;
        PackageUtilService.postPackageSaveFunction = packageSaved;

        getEditData().then(() => {
            this.isLongformEditor = this.packageObject.categoryType.name === 'Long Form';

            // queryForProperties called by package-edit-controller
            this.maxTitleLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxTitleLength', -1);
            this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxShortDescLength', -1);
            this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxLongDescLength', -1);
            this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('package.longForm.maxKeywordsLength', -1);

            if (!this.isLongformEditor) {
                // default to long form values if there's no
                // shortForm-specific properties set
                this.maxTitleLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxTitleLength', this.maxTitleLength);
                this.maxShortDescLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxShortDescLength', this.maxShortDescLength);
                this.maxLongDescLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxLongDescLength', this.maxLongDescLength);
                this.maxKeywordsLength = DynamicPropertiesService.getPropValueAsInt('package.shortForm.maxKeywordsLength', this.maxKeywordsLength);
            }

            const requiredFields = DynamicPropertiesService.getPropValueAsArray('translatable.text.package.required.properties', []);

            this.translatableMetadataFields = [
                {
                    name: 'title',
                    title: 'Title',
                    maxChars: this.maxTitleLength,
                    required: _.includes(requiredFields, 'title'),
                },
                {
                    name: 'shortDescription',
                    title: 'Short Description',
                    maxChars: this.maxShortDescLength,
                    required: _.includes(requiredFields, 'shortDescription'),
                },
                {
                    name: 'longDescription',
                    title: 'Long Description',
                    maxChars: this.maxLongDescLength,
                    required: _.includes(requiredFields, 'longDescription'),
                },
                {
                    name: 'keywords',
                    title: 'Keywords',
                    type: 'multi',
                    maxChars: this.maxKeywordsLength,
                    required: _.includes(requiredFields, 'keywords'),
                },
            ];

            this.pendingPartnerPackages = this.packageObject.pendingPartnerPackages;
        });
    };

    this.$onChanges = (changes: JS5Object) => {
        this.pendingPartnerPackages = changes.pendingPartnerPackages.currentValue;
    };

    this.$postLink = () => {
        $timeout(() => {
            PackageUtilService.editorForm = this.packageMetadataEditorForm;
        });
    };
}

angular
    .module('prism-ui.package')
    .component('packageMetadataView', {
        controller: PackageMetadataViewController,
        templateUrl: 'package/editor/components/view/metadata/packagemetadata-view-template.html',
        bindings: {
            packageObject: '=',
            loadingIndicator: '=',
            pkgEditCtrl: '=',	// not ideal - breaks the least stuff until we can refactor
            pendingPartnerPackages: '<'
        },
    });
